const initState = function () {
  return {
    selectionComponents: {
      selectionShippingLogistics: null,
      selectionInsuranceExtras: null,
      selectionReceptionLogistics: null,
      selectionFinancialCosts: null,
      selectionInlandTransportation: null,
      selectionManagementExpenses: null,
      selectionProceduresPermits: null,
      selectRatesTaxes: null,
      selectTerminalManagement: null,
      selectionInternationalTransport: null
    }
  }
}

const componentSelectionStore = {
  state: {
    selectionComponents: { ...initState() }
  },
  mutations: {
    setSelectionComponent (state, selectionComponents) {
      state.selectionComponents = selectionComponents
    },
    resetComponentSelectionStore (state) {
      state.selectionComponents = { ...initState() }
    }
  },
  actions: {
  },
  getters: {
    storeSelectionComponents: state => state.selectionComponents
  }

}
export default componentSelectionStore
